/**
 * DiscountStore orchestrates all discount-related child stores.
 * Child stores will be added here:
 * - promoCodeStore: PromoCodeStore
 * - generalDiscountStore: GeneralDiscountStore
 * - productCreditsStore: ProductCreditsStore
 * - giftCardStore: GiftCardStore
 */
export class DiscountStore {
  clearAll = (): void => {
    // Will call clear() on all child stores when implemented
  }

  refreshAll = async (): Promise<void> => {
    // Will refresh all child stores in parallel when implemented
  }
}
